module.exports = __webpack_public_path__ + "img/isyanfa.0ac77e10.png";